import React from 'react'
import {Popup} from 'semantic-ui-react'
import {PoeChip, POE_POPUP_TEXT} from '../poe-chip'

// shipping_class is set by hand on the sales order (No / FOB China / FOB NY / POE)
const poePopup = (po) => {
  return (
    po.shippingClass !== 'POE'
    ?
    null
    :
    <Popup
      size='mini'
      header='POE order'
      content={POE_POPUP_TEXT}
      position='bottom left'
      trigger={<PoeChip/>}
    />
  )
}

export {poePopup}
